import { useRef, useCallback } from "react";

export function useSmartScroll() {
  const messagesEndRef = useRef(null);

  const scrollToBottom = useCallback(() => {
    setTimeout(() => {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 150);
  }, []);

  const scrollToMessage = useCallback((messageId) => {
    // Use multiple attempts with increasing delays to ensure DOM is ready
    const attempt = (delay) => {
      setTimeout(() => {
        const el = document.querySelector(`[data-message-id="${messageId}"]`);
        if (el) {
          const container = el.closest('[data-testid="chat-messages-area"]');
          if (container) {
            const elRect = el.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            const offset = elRect.top - containerRect.top + container.scrollTop - 12;
            container.scrollTo({ top: offset, behavior: "smooth" });
          }
        }
      }, delay);
    };
    // Try at 100ms (for fast renders) and 350ms (for slower gallery renders)
    attempt(100);
    attempt(350);
  }, []);

  return { messagesEndRef, scrollToBottom, scrollToMessage };
}
